<template>
  <v-fade-transition>
    <v-container
      v-if="loading"
      class="helmi-loader"
      :class="backgroundColor"
    >
      <v-row
        align-content="center"
        class="fill-height helmi-loader__content"
        :style="`min-height: ${minHeight}`"
        justify="center"
      >
        <v-col
          class="text-subtitle-1 text-center"
          cols="12"
        >
          Ladataan...
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            :color="color"
            height="2"
            indeterminate
            rounded
          />
        </v-col>
      </v-row>
    </v-container>
  </v-fade-transition>
</template>

<script>
export default {
  name: 'HelmiLoader',

  props: {
    backgroundColor: {
      type: String,
      default: 'white',
    },

    color: {
      type: String,
      default: 'secondary',
    },

    loading: {
      type: Boolean,
      default: false,
    },

    minHeight: {
      type: String,
      default: '400px',
    },
  },
};
</script>

<style lang="scss">
.helmi-loader {
  bottom: 0;
  left: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 100;

  &__content {
    max-height: calc(100vh - 64px);
  }
}
</style>
